module.exports = __webpack_public_path__ + "img/swiper1.ad8e721b.jpg";